import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      client: {
        regular: false,
        individualEntrepreneur: false,
      },
    };
  },
  mounted() {
    this.client = {
      ...this.client,
      regular: this.isClientRegular,
      individualEntrepreneur: this.isClientIndividualEntrepreneur,
    };
  },
  computed: {
    ...mapGetters('clientModule', ['isClientRegular', 'isClientIndividualEntrepreneur']),
  },
  methods: {
    ...mapActions('clientModule', ['setClientRegular', 'setClientIndividualEntrepreneur']),
  },
  watch: {
    'client.regular'(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setClientRegular(newValue);
      }
    },
    'client.individualEntrepreneur'(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setClientIndividualEntrepreneur(newValue);
      }
    },
  },
};
